import { render } from "./PermissionsPanel.vue?vue&type=template&id=5445cc58&ts=true"
import script from "./PermissionsPanel.vue?vue&type=script&lang=ts"
export * from "./PermissionsPanel.vue?vue&type=script&lang=ts"

import "./PermissionsPanel.vue?vue&type=style&index=0&id=5445cc58&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__